import CriterionContent from 'components/admin/manage/edd/criterion/CriterionContent';
import React from 'react';

export const CriterionPage = () => {
  return <CriterionContent />;
};
